import React from "react";
import VardegrundBeslutad from "../../images/vardegrund_beslutad_2016.jpg";

const ValuesText = () => {
  return (
    <div>
      <h2>Djurgårdens IF tar ställning mot rysk återkomst till internationell idrott</h2>
      <p>
        Djurgårdens IF alliansstyrelse har beslutat att uppmana samtliga sina
        medlemsföreningar att verka för fortsatt utestängning av rysk
        idrottsrepresentation från internationella tävlingar och utbyten.
        Beslutet omfattar också rekrytering till elitverksamhet och
        sponsorsamarbeten med företag som bedriver verksamhet i Ryssland.
        Ställningstagandet ska upprätthållas så länge Rysslands angreppskrig mot
        Ukraina fortsätter.
      </p>

      <h1>Djurgårdens värdegrund</h1>

      <h2>Vår vision</h2>
      <p>
        <em>
          ”Djurgårdens Idrottsförening får <strong>människor att växa genom
          idrottens gemenskap</strong>, för samhällets bästa”
        </em>
      </p>

      <h2>Vår position</h2>
      <p>
        <em>
          Stockholms Stolthet – <strong>Sveriges ledande idrottsförening</strong>
        </em>
      </p>

      <h2>Våra nio framgångsprinciper</h2>

      <h3>1. Stå upp för rättvisa</h3>
      <p>
        <em>- Vi låter idrottens rättvisa ideal genomsyra allt vi gör.</em>
      </p>

      <h3>2. Tydligt ledarskap</h3>
      <p>
        <em>- Vi visar kraften i höga ambitioner, lyhördhet och civilkurage.</em>
      </p>

      <h3>3. Tar socialt ansvar</h3>
      <p>
        <em>
          - Vi breddar idrottsintresset, erbjuder tillhörighet och är en aktiv
          positiv kraft i samhället.
        </em>
      </p>

      <h3>4. Professionell inställning</h3>
      <p>
        <em>
          - Vi strävar efter hög kompetens, kvalitet och att lära oss i allt vi
          gör.
        </em>
      </p>

      <h3>5. Goda förebilder</h3>
      <p>
        <em>
          - Vi visar respekt, värdighet och är stolta djurgårdsambassadörer.
        </em>
      </p>

      <h3>6. Varm gemenskap</h3>
      <p>
        <em>- Vi är välkomnande, omtänksamma och lyfter varandra.</em>
      </p>

      <h3>7. Alltid visa vilja</h3>
      <p>
        <em>- Vi slutar aldrig kämpa och ser vilja som talang.</em>
      </p>

      <h3>8. Uppmuntra mod</h3>
      <p>
        <em>- Vi utmanar det invanda, vågar testa nytt och är innovativa.</em>
      </p>

      <h3>9. Glädje och kärlek</h3>
      <p>
        <em>- Vi delar entusiasm, inspiration och hopp.</em>
      </p>

      <figure className="values-figure">
        <img
          src={VardegrundBeslutad}
          alt="Gruppbild på representanter från Djurgårdens alliansföreningar när värdegrunden beslutades."
        />
        <figcaption>Värdegrunden beslutad 10 mars 2016</figcaption>
      </figure>
    </div>
  );
};

export default ValuesText;
